module.exports = __webpack_public_path__ + "img/Vector.82a2411e.svg";